// reactivation.ts — MCC intelligence. The reactivation queue client: a ranked
// "who to re-engage" list composed from smart-list segments + lead scores.
// Read-only; the row actions reuse the campaigns + activities clients.

import { request } from './request'

export interface ReactivationCandidate {
  profile_id: string
  name: string
  email: string | null
  lifecycle_stage: string
  segments: string[]
  relationship_value: number
  days_quiet: number | null
  lead_score: number | null
  emailable: boolean
  has_open_task: boolean
  reactivation_priority: number
}

export interface ReactivationSegment {
  key: string
  label: string
  rule: Record<string, unknown>
}

export const reactivationApi = {
  list: () =>
    request<{
      ok: boolean
      candidates: ReactivationCandidate[]
      total: number
      segments: ReactivationSegment[]
    }>('/api/admin/reactivation'),
}
